import React from 'react';

const AsambleaEmbed = () => {
  return (
    <div style={{ width: '100%', height: '85vh', padding: 0 }}>
      <iframe
        src="https://us02web.zoom.us/meeting/register/TfJiEo_mTuSYvDgSDtPrew"
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="Registro Asamblea"
        allowFullScreen
      />
    </div>
  );
}

export default AsambleaEmbed;
